import Edit from './Edit';
import List from './List';
import Show from './Show';

export default {
  name: 'hris_location_mappings',
  list: List,
  show: Show,
  edit: Edit,
  options: {
    label: 'HRIS Location Mappings',
    group: false,
  },
};
